import React from 'react'
import './label.scss'

/**
 * Label component displays a styled label with text content.
 *
 * @param {string} props.text - The text content of the label.
 * @param {string} [props.textColor='black'] - The color of the label's text (black,white).
 * @param {string} [props.backgroundColor='gray'] - The background color of the label (gray, green, orange).
 * @param {string} [props.size='medium'] - The size of the label (small, medium, large).
 * @param {boolean} [props.article=false] - Determines if the label represents an article (rounded border top or no).
 * @returns {JSX.Element} - A React JSX element representing the styled label.
 */
export const Label = ({
  text,
  textColor = 'black',
  backgroundColor = 'gray',
  size = 'medium',
  article = false,
}) => {
  return (
    <div
      className={`label-tag text-${textColor} background-${backgroundColor} ${size} ${
        (article && 'article') || ''
      }`}
    >
      {text}
    </div>
  )
}
